import { UID } from 'shared/api/query/constants';
import { azureDevOpsAggregationMode, azureDevOpsFilterMode } from 'shared/constants.json';
import { azureDevOpsQuery as azureDevOpsQueryConfig, dataSource as dataSourceConfig, goal as goalConfig } from 'shared/api/query/configs.json';

export const azureDevOpsQueryChildren = [
  { attr: UID },
  {
    attr: azureDevOpsQueryConfig.edges.dataSource,
    model: dataSourceConfig.model,
    default: null,
    children: [{ attr: UID }],
  },
  {
    attr: azureDevOpsQueryConfig.edges.goal,
    model: goalConfig.model,
    children: [{ attr: UID }],
  },
  { attr: azureDevOpsQueryConfig.edges.alwaysSync, default: false },
  { attr: azureDevOpsQueryConfig.edges.error, default: null },
  { attr: azureDevOpsQueryConfig.edges.organizationId, default: null },
  { attr: azureDevOpsQueryConfig.edges.organizationName, default: null },
  { attr: azureDevOpsQueryConfig.edges.projectId, default: null },
  { attr: azureDevOpsQueryConfig.edges.projectName, default: null },
  { attr: azureDevOpsQueryConfig.edges.projectUrl, default: null },

  { attr: azureDevOpsQueryConfig.edges.filterMode, default: azureDevOpsFilterMode.sharedQueries },
  { attr: azureDevOpsQueryConfig.edges.sharedQueryId, default: null },
  { attr: azureDevOpsQueryConfig.edges.sharedQueryName, default: null },
  { attr: azureDevOpsQueryConfig.edges.sharedQueryUrl, default: null },
  { attr: azureDevOpsQueryConfig.edges.filterWorkItemType, default: null },
  { attr: azureDevOpsQueryConfig.edges.filterWorkItemIDs, default: [] },
  { attr: azureDevOpsQueryConfig.edges.filterWorkItemNames, default: [] },

  { attr: azureDevOpsQueryConfig.edges.aggregationWorkItemType, default: null },
  { attr: azureDevOpsQueryConfig.edges.aggregationMode, default: azureDevOpsAggregationMode.absolute },
  { attr: azureDevOpsQueryConfig.edges.aggregationWorkItemFieldId, default: null },
];
